module.exports = __webpack_public_path__ + "static/sidebar-7c41452e12011ee4e11f346f25bd0810.gif";